import SicCodesMapping from "../../../mappings_dir/sic_codes.json";

export const SIC_CODES: { [key: string]: string } =
  SicCodesMapping.sic_codes as { [key: string]: string };

/**
 * Formats a SIC code into a display string.
 * e.g. "7213 (Linen Supply)" or just "7213" if no description found.
 */
export const formatSicDisplay = (
  sicCode: string | undefined | null
): string => {
  if (!sicCode) return "";
  const desc = SIC_CODES[sicCode];
  return desc ? `${sicCode} (${desc})` : sicCode;
};
